import React, { useState, useEffect } from 'react';
import {EditOutlined} from '@ant-design/icons';
import { Button, Modal, Form, Input, Select, InputNumber } from 'antd';
import { FetchVariable } from '../../../Components/FetchVariable/FetchVariable';
import axios from 'axios';

const{Option}=Select

const LaborUpdateForm = ({ visible, onCreate, onCancel, record }) => {

  let labor = record
  const [form] = Form.useForm();
  const [laborID]=useState(labor.LaborID)
  const [vehicleID]=useState(labor.VehicleID)
  const [employeeID]=useState(labor.EmployeeID)
  const [laborHours]=useState(labor.LaborHours)

  const [vehicleData, setVehicleData] = useState()
  const [employeeData, setEmployeeData] = useState()


  useEffect(()=>{
    let apiURL = `${FetchVariable.Heroku}/vehicle/`
      axios.get(apiURL)
      .then((res)=>{
        let data = res.data
        setVehicleData(data)
      })
    },[])
  
  useEffect(()=>{
    let apiURL = `${FetchVariable.Heroku}/employee/`
      axios.get(apiURL)
      .then((res)=>{
        let data = res.data
        setEmployeeData(data)
      })
    },[])

  return (
    <Modal
      visible={visible}
      title="Update Labor"
      okText="Update"
      cancelText="Cancel"
      onCancel={onCancel}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            form.resetFields();
            onCreate(values);
          })
          .catch((info) => {
            console.log('Validate Failed:', info);
          });
      }}
    >
      <Form
        form={form}
        layout="vertical"
        name="LaborUpdate"
        initialValues={{
            LaborID:laborID,
            VehicleID:vehicleID,
            EmployeeID:employeeID,
            LaborHours:laborHours,
        }}
      >
        <Form.Item
          name="LaborID"
          label="Labor ID"
        >
            <Input disabled/>
        </Form.Item>
        <Form.Item name="VehicleID" label="Vehicle">
          <Select>
            {vehicleData?.map(vehicle=><Option value={vehicle.VehicleID} key={vehicle.VehicleID}>Vehicle ID: {vehicle.VehicleID} - Vehicle VIN:{vehicle.VehicleVIN}</Option>)}
          </Select>        
        </Form.Item>
        <Form.Item name="EmployeeID" label="Employee">
          <Select 
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            showSearch>
            {employeeData?.map(employee=><Option value={employee.EmployeeID} key={employee.EmployeeID}>{employee.EmployeeName}</Option>)}
          </Select>   
        </Form.Item>

        <Form.Item
          name="LaborHours"
          label="Labor Hours"
        >
              <InputNumber style={{ width: '50%' }} addonAfter="Hour" step='1'min="0"max="10"/>
        </Form.Item>
      </Form>
    </Modal>
  );
};

const LaborUpdate = (props) => {

  const [visible, setVisible] = useState(false);
  const onCreate = (values) => {
    props.updateLabor(values)
    setVisible(false);
  };

  return (
    <div>
      <Button
        type="primary"
        onClick={() => {
          setVisible(true);
        }}

        icon={<EditOutlined />}
      >
        
      </Button>
      <LaborUpdateForm
        visible={visible}
        onCreate={onCreate}
        onCancel={() => {
          setVisible(false);
        }}
        record={props.record}
      />
    </div>
  );
};

export default LaborUpdate